<div class="character-counter-container {{position}}">
  @if (isArdPopnacht) {
    <div class="count-text" *ngIf="charSequenceLength >= 0">
      <span class="count-text-warning" *ngIf="charSequenceLength >= maxCharsWarning">Achtung: {{maxCharsWarning}} Zeichen erreicht</span>
      {{charSequenceLength}}/{{maxChars}}
    </div>
  } @else {
      @if (charSequenceLength >= 0) {
        <div class="count-text">
          {{ charSequenceLength }}/{{ maxChars }}
        @if (charSequenceLength >= maxChars) {
          <span class="count-text-warning">Achtung: {{ maxChars }} Zeichen erreicht</span>
        } @else if (charSequenceLength >= maxCharsWarning && charSequenceLength < maxChars) {
          <span class="count-text-warning">Achtung: Maximale Zeichenanzahl (fast) erreicht!</span>
        }
        </div>
      }
  }
</div>
